// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/workload_thresholds.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/schools/v1/resources/workload_thresholds.proto.
 */
export const file_studyo_today_schools_v1_resources_workload_thresholds = /*@__PURE__*/
  fileDesc("CjtzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvd29ya2xvYWRfdGhyZXNob2xkcy5wcm90bxIhc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEucmVzb3VyY2VzIikKEldvcmtsb2FkVGhyZXNob2xkcxITCgtkYWlseV9saW1pdBgBIAEoBUIpqgImU3R1ZHlvLlRvZGF5LlNjaG9vbHMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw");

/**
 * Describes the message studyo.today.schools.v1.resources.WorkloadThresholds.
 * Use `create(WorkloadThresholdsSchema)` to create a new message.
 */
export const WorkloadThresholdsSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_resources_workload_thresholds, 0);

